import React from "react"
import PropTypes from "prop-types"

/**
 * Circular language flag — matches profile `_profile_languages` markup
 * (server-rendered SVG via `flag_html` from ConnectsHelper).
 */
function ProfileLanguageFlag({ flagHtml, size }) {
  if (!flagHtml) return null

  const style = size ? { width: size, height: size } : undefined

  return (
    <span
      className="connectMemberCard__languageFlagHost"
      style={style}
      dangerouslySetInnerHTML={{ __html: flagHtml }}
    />
  )
}

ProfileLanguageFlag.propTypes = {
  flagHtml: PropTypes.string,
  size: PropTypes.number,
}

export default ProfileLanguageFlag
